interface FooterLinkProps {
	name: string;
	value: string;
}
export const DATA_FOOTER_INFO: string[] = ["ABC LAB", "02-303-8800", "서울시 성동구 왕십리로 115, 헤이그라운드 서울숲점"];
export const DATA_FOOTER_LINK: FooterLinkProps[] = [
	{
		name: "facebook",
		value: "https://www.facebook.com/ABCLAB2020"
	},
	{
		name: "instagram",
		value: "https://www.instagram.com/abclab.kr/"
	}
];
